<form [formGroup]="form">
  <div class="p-fluid">
    <!-- Redni broj od -->
    <kodit-field fieldLabel="Redni broj od:" fieldLabelFor="redniBrojOd">
      <kodit-number-input
        formCtrlId="redniBrojOd"
        [formCtrl]="form.controls.redniBrojOd"
        [ctrlOnlyIntegers]="true"
      ></kodit-number-input>
    </kodit-field>
    <!-- Redni broj od -->
    <kodit-field fieldLabel="Redni broj do:" fieldLabelFor="redniBrojDo">
      <kodit-number-input
        formCtrlId="redniBrojDo"
        [formCtrl]="form.controls.redniBrojDo"
        [ctrlOnlyIntegers]="true"
      ></kodit-number-input>
    </kodit-field>
    <!-- Godina nastanka -->
    <kodit-field fieldLabel="Godina nastanka">
      <kodit-dropdown
        [options]="godineItems"
        [formCtrl]="form.controls.godinaDokumenta!"
      ></kodit-dropdown>
    </kodit-field>
    <!-- Jedinica roka cuvanja -->
    <kodit-field fieldLabel="Rok čuvanja prikazati u:">
      <div class="flex align-items-center gap-4 p-mb-3">
        <p-radioButton
          name="rokCuvanjaJedinica"
          [value]="0"
          [formControl]="form.controls.rokCuvanjaJedinica"
        ></p-radioButton>
        <label
          class="cursor-pointer p-ml-1"
          (click)="form.controls.rokCuvanjaJedinica.patchValue(0)"
          >Mesecima</label
        >

        <p-radioButton
          class="p-ml-3"
          name="rokCuvanjaJedinica"
          [value]="1"
          [formControl]="form.controls.rokCuvanjaJedinica"
        ></p-radioButton>
        <label
          class="cursor-pointer p-ml-1"
          (click)="form.controls.rokCuvanjaJedinica.patchValue(1)"
          >Godinama</label
        >
      </div>
    </kodit-field>
    <!-- Redosled brojeva -->
    <kodit-field fieldLabel="Redosled brojeva:">
      <div class="flex align-items-center gap-4 p-mb-3">
        <p-radioButton
          name="redniBrojSortOrder"
          [value]="-1"
          [formControl]="form.controls.redniBrojSortOrder"
        ></p-radioButton>
        <label
          class="cursor-pointer p-ml-1"
          (click)="form.controls.redniBrojSortOrder.patchValue(-1)"
          >Opadajuće</label
        >

        <p-radioButton
          class="p-ml-3"
          name="redniBrojSortOrder"
          [value]="1"
          [formControl]="form.controls.redniBrojSortOrder"
        ></p-radioButton>
        <label
          class="cursor-pointer p-ml-1"
          (click)="form.controls.redniBrojSortOrder.patchValue(1)"
          >Rastuće</label
        >
      </div>
    </kodit-field>
  </div>

  <hr />

  <p-message
    severity="info"
    text="Akcijom štampanja redovi će biti zaključani i izmene neće biti dozvoljene.
        Ukoliko ste napravili grešku, uvek možete sami otključati redove."
  ></p-message>
</form>

<div class="loading-card" *ngIf="!form || !isDropdownLoaded">
  <div class="loading-skeleton-bar"></div>
  <div class="loading-skeleton-bar"></div>
  <div class="loading-skeleton-bar"></div>
  <div class="loading-skeleton-bar"></div>
  <div class="loading-skeleton-bar"></div>
  <div class="loading-skeleton-bar"></div>
  <div class="loading-skeleton-bar"></div>
  <div class="loading-skeleton-bar"></div>
</div>
